import React from 'react';
import {deleteRecording, exportRecording, listRecordings} from '../lib/recording-store.js';

function duration(seconds) {
  const value = Number(seconds) || 0;
  return `${Math.floor(value / 60)}:${String(value % 60).padStart(2, '0')}`;
}

export default class AccRecordingsView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {loading: true, authorized: false, recordings: [], error: null};
  }

  componentDidMount() { this.load(); }

  load = async () => {
    try {
      const policy = await this.props.kaltiq.recordingPolicy();
      if (!policy.granted) {
        this.setState({loading: false, authorized: false, recordings: []});
        return;
      }
      this.setState({loading: false, authorized: true, recordings: await listRecordings(), error: null});
    } catch (err) {
      this.setState({loading: false, error: err.message});
    }
  };

  remove = async id => {
    if (!window.confirm('Delete this encrypted recording from this browser?')) return;
    try { await deleteRecording(id); await this.load(); } catch (err) { this.setState({error: err.message}); }
  };

  render() {
    if (this.state.loading) return <div className="panel-form-row">Loading recordings…</div>;
    if (!this.state.authorized) return <div className="panel-form-row">Recording is not enabled for this account.</div>;
    return <div className="scrollable-panel kq-panel"><div className="panel-form-column">
      <div className="kq-checkout-hero"><i className="material-icons">encrypted</i><div>
        <strong>Private call recordings</strong>
        <p>Recordings are AES-256-GCM encrypted in this browser. Exporting creates an unencrypted copy in Downloads.</p>
      </div></div>
      {this.state.error ? <div className="kq-error">{this.state.error}</div> : null}
      {this.state.recordings.length === 0 ? <p className="kq-muted">No recordings on this device.</p> : null}
      <ul className="kq-recording-list">{this.state.recordings.map(record => <li key={record.id}>
        <div><strong>{record.peer || 'Kaltiq call'}</strong><div className="small kq-muted">
          {new Date(record.createdAt).toLocaleString()} · {duration(record.durationSeconds)} · {record.audioOnly ? 'Audio' : 'Video'}
        </div></div>
        <div><button className="outline" onClick={() => exportRecording(record.id).catch(err => this.setState({error: err.message}))}>Export</button>
          <button className="danger" onClick={() => this.remove(record.id)}>Delete</button></div>
      </li>)}</ul>
    </div></div>;
  }
}
